export default __webpack_public_path__ + "static/media/google_logo.479a3373.png";